import { render, staticRenderFns } from "./is_01_com.vue?vue&type=template&id=00a74bfa&scoped=true&"
import script from "./is_01_com.vue?vue&type=script&lang=js&"
export * from "./is_01_com.vue?vue&type=script&lang=js&"
import style0 from "./is_01_com.vue?vue&type=style&index=0&id=00a74bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a74bfa",
  null
  
)

export default component.exports